export default __webpack_public_path__ + "b588cb78dd6dc699af517dd5dc0a4a6f.png";